(function () {
  'use strict';
  if (window.bwHubSpotConsentBridge) return;
  window.bwHubSpotConsentBridge = true;
  var lastAllowed = null;
  var loaded = false;
  function syncConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;
    var allowed = privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
    if (allowed === lastAllowed) return;
    lastAllowed = allowed;
    if (!allowed) {
      if (loaded || document.getElementById('hs-script-loader')) {
        (window._hsq = window._hsq || []).push(['doNotTrack']);
        (window._hsp = window._hsp || []).push(['revokeCookieConsent']);
      }
      return;
    }
    (window._hsq = window._hsq || []).push(['doNotTrack', {track: true}]);
    if (document.getElementById('hs-script-loader') ||
        document.querySelector('script[src*="hs-scripts.com/25309101"]')) return;
    loaded = true;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = 'https://js-eu1.hs-scripts.com/25309101.js';
    script.onerror = function () {
      loaded = false;
      script.remove();
      lastAllowed = null;
    };
    document.body.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  function init() {
    if (!window.Shopify) return;
    if (window.Shopify.customerPrivacy) {
      syncConsent();
    } else if (window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
        if (!error) syncConsent();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();